import React from "react";
import { Card, Col, Input, Row, Table, Typography } from "antd";
import useProcurementStore from "store/procurement_store";
import { PROCUREMENT_TYPES } from "types";

const { Text } = Typography;

const DataComponent =  () => {
  const { demandIntakeData, procurement_header_data } =  useProcurementStore((state) => ({
    demandIntakeData: state.demandIntakeData,
    procurement_header_data: state.procurement_header_data
  }));

  const data = demandIntakeData?.resources;

   const resourcesColumns = [
    {
      title: "",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "No. of vCPUs",
      dataIndex: "est_vcpus",
      key: "est_vcpus",
    },
    {
      title: "RAM (in GB)",
      dataIndex: "est_memory",
      key: "est_memory",
    },
    {
      title: "Storage (in TB)",
      dataIndex: "est_diskspace",
      key: "est_diskspace",
    },
    {
      title: "1 Gbps 4 port NICs",
      dataIndex: "est_nics",
      key: "est_nics",
    },
    {
      title: `${demandIntakeData?.nic_speed} Gbps 4 port NICs`,
      dataIndex: "nics_node",
      key: "nics_node",
    },
  ];

   const resourcesData = [
    {
      key: "resources",
      name: <Text strong>Resources</Text>,
      est_memory: <Text>{data?.memory_}</Text>,
      est_vcpus: <Text>{data?.cpu_cores}</Text>,
      est_diskspace: <Text>{data?.storage_tb}</Text>,
      est_nics: (
        <Text>{demandIntakeData?.gbps_4_port_NICs}</Text>
      ),
      nics_node: (
        <Text>{demandIntakeData?.speed_gbps_4_port_NICs || 0}
        </Text>
      ),
    },
  ];

  return (
    <Card 
      className="data-component-card"
      style={{
        marginBottom: "24px",
        border: "1px solid #E5E7EB",
        borderRadius: "8px",
        boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)"
      }}
    >
      <div style={{
        padding: "16px 24px",
        borderBottom: "1px solid #E5E7EB",
        background: "#F9FAFB"
      }}>
        <Text strong style={{ 
          fontSize: "16px", 
          fontWeight: 600, 
          color: "#1F2937" 
        }}>
          Sizing Details
        </Text>
      </div>
      <div style={{ padding: "24px" }}>
        <Row style={{ marginBottom: "24px" }}>
          <Col span={18}>
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <Text style={{ 
                fontWeight: 500, 
                color: "#374151",
                fontSize: "14px"
              }}>
                {procurement_header_data?.procurement_type === PROCUREMENT_TYPES.NEW
                  ? "Estimated cluster size:"
                  : "Additional Nodes:"}
              </Text>
              <Input
                style={{ 
                  width: "300px",  
                  color: "#1F2937",
                  fontWeight: 500
                }}
                value={demandIntakeData?.['estimated_tshirt_size']}
                disabled
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Table
              dataSource={resourcesData}
              columns={resourcesColumns}
              pagination={false}
              bordered={false}
              size="middle"
              style={{ marginBottom: "0" }}
            />
          </Col>
        </Row>
      </div>
    </Card>
  );
};

export default DataComponent;
